module.exports = __webpack_public_path__ + "static/media/possible2.047e77f0.webp";